import { useCallback, useMemo, useState } from "react";
import Content from "../Content";
import { FilterItemCountsWithSelect } from "types";
import VLAccordian from "views/components/Accordian";
import { checkIsUnselectable } from "helpers/utility/utilities";
import ContentBodyLoader from "../Content/ContentBody/ContentBodyLoader";

import styles from "../style.module.scss";
import { MdOutlineTopic } from "react-icons/md";

const METADATA_SECTION_VIDEO_CONTENT_ID = "metadata-video-1";
const METADATA_SECTION_SOURCES_CONTENT_ID = "metadata-sources-1";
const COMBINED_ID =
  METADATA_SECTION_VIDEO_CONTENT_ID + METADATA_SECTION_SOURCES_CONTENT_ID;

function NoMetadata() {
  return (
    <div className={styles.noDataWrapper}>
      <div className={styles.noData}>
        Currently no Metadata available in this cluster
      </div>
    </div>
  );
}

const MetadataSources = ({
  models,
  sources,
  isLoading,
  selectedID,
  setSelectedID,
  useAccordionHeight,
}: any) => {
  const combinedSources = useMemo(
    () => [...models, ...sources],
    [models, sources],
  );

  const getIsUnselectable = useCallback(
    (value: FilterItemCountsWithSelect) => {
      return checkIsUnselectable(value, models, sources);
    },
    [sources, models],
  );

  if (sources.length > 0) {
    return (
      <>
        <Content
          data={sources}
          type={"sources"}
          title={"Sources"}
          sectionType={"sources"}
          isLoading={isLoading}
          selectedID={selectedID}
          sources={combinedSources}
          setSelectedID={setSelectedID}
          getIsUnselectable={getIsUnselectable}
          id={METADATA_SECTION_SOURCES_CONTENT_ID}
          useAccordionHeight={useAccordionHeight}
        />
      </>
    );
  } else {
    return <></>;
  }
};

const MetadataSectionContentVideo = ({
  videoData,
  isLoading,
  selectedID,
  setSelectedID,
}: any) => {
  if (videoData.length > 0) {
    return (
      <Content
        title={"Videos"}
        data={videoData}
        type={"file-display"}
        isLoading={isLoading}
        selectedID={selectedID}
        sectionType={"metadata"}
        setSelectedID={setSelectedID}
        id={METADATA_SECTION_VIDEO_CONTENT_ID}
      />
    );
  } else {
    return <></>;
  }
};

const MetadataSectionContent = ({
  sectionHeight,
  videoData,
  isLoading,
  sources,
  models,
}: any) => {
  const [selectedID, setSelectedID] = useState(null);
  const useAccordionHeight = !(!!sources.length && !!videoData.length);

  return (
    <div
      className={styles.section}
      style={{ height: !!sectionHeight ? sectionHeight : "max-content" }}
    >
      <MetadataSources
        models={models}
        sources={sources}
        isLoading={isLoading}
        selectedID={selectedID}
        setSelectedID={setSelectedID}
        useAccordionHeight={useAccordionHeight}
      />

      <MetadataSectionContentVideo
        videoData={videoData}
        isLoading={isLoading}
        selectedID={selectedID}
        setSelectedID={setSelectedID}
      />
    </div>
  );
};

const MetadataSection = ({
  videoData,
  metadataRef,
  sources,
  models,
  sectionHeight,
  isLoading,
}: any) => {
  const hasData = videoData.length > 0 || sources.length > 0;
  const allowResize = videoData.length > 5 || sources.length > 5;
  const handleDisplay = () => {
    if (isLoading && !hasData) {
      return (
        <div className={styles.loadingBox}>
          <ContentBodyLoader center />
        </div>
      );
    } else if (hasData) {
      return (
        <MetadataSectionContent
          models={models}
          sources={sources}
          videoData={videoData}
          isLoading={isLoading}
          sectionHeight={sectionHeight}
        />
      );
    } else return <NoMetadata />;
  };

  return (
    <div className={styles.metadataWrapper} ref={metadataRef}>
      <VLAccordian
        key="Metadata"
        title="Metadata"
        id={COMBINED_ID}
        allowResize={allowResize}
        isLoading={isLoading && hasData}
        className={styles.metadataSectionAccordian}
        icon={<MdOutlineTopic size={"1.55em"} />}
        initiallyClosed
      >
        {handleDisplay()}
      </VLAccordian>
    </div>
  );
};
export default MetadataSection;
